import * as ex from 'excalibur';
import { AsepriteResource } from '@excaliburjs/plugin-aseprite';

// Create resources for specific Aseprite files
const Resources = {
  // Animal sprites
  Bird: new AsepriteResource('bird.aseprite'),
  Rabbit: new AsepriteResource('rabbit.aseprite'),
  Deer: new AsepriteResource('deer.aseprite'),
  Wolf: new AsepriteResource('wolf.ase'),
  Fish: new AsepriteResource('fish.aseprite'),
  Bear: new AsepriteResource('bear.aseprite'),

  // Plant sprites
  GrassDense: new AsepriteResource('grass_dense.aseprite'),
  GrassSparse: new AsepriteResource('grass_sparse.aseprite'),
  TreeSmall: new AsepriteResource('tree_small.aseprite'),
  TreesLarge: new AsepriteResource('trees_large.aseprite'),
  Flower: new AsepriteResource('flower.aseprite'),
  Sprout: new AsepriteResource('sprout.aseprite'),
  SproutMature: new AsepriteResource('sprout_mature.aseprite')
};

// Create a loader with all resources
const loader = new ex.Loader([
  Resources.Bird,
  Resources.Rabbit,
  Resources.Deer,
  Resources.Wolf,
  Resources.Fish,
  Resources.Bear,
  Resources.GrassDense,
  Resources.GrassSparse,
  Resources.TreeSmall,
  Resources.TreesLarge,
  Resources.Flower,
  Resources.Sprout,
  Resources.SproutMature
]);

// Export the Resources object and loader
export { Resources, loader };
